import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#7c3aed", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#ede9fe", border: "1px solid #c4b5fd", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#5b21b6", lineHeight: 1.6 },
}));

const DEFAULT = {
  msgSemTreinos: "Você não possui um plano de treinos cadastrado.",
};

const FlowBuilderScTreinosModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ ...DEFAULT, ...data.data.data });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    const label = "SC — Treinos";
    if (open === "edit") {
      onUpdate(data.id, { data: { label, data: cfg } });
    } else {
      onSave({ label, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>Sys Clínica — Treinos</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Lista as semanas restantes do mês atual e aguarda o paciente escolher uma.<br />
            Ao escolher, exibe os dias e exercícios do cronograma para aquela semana.
          </Typography>
        </Box>

        <TextField
          label="Mensagem quando sem plano de treinos"
          value={cfg.msgSemTreinos}
          onChange={(e) => setCfg({ ...cfg, msgSemTreinos: e.target.value })}
          fullWidth margin="dense" variant="outlined" multiline minRows={2}
        />

        <Box style={{ marginTop: 16, padding: 12, background: "#f5f3ff", borderRadius: 8, border: "1px solid #c4b5fd" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#5b21b6", fontWeight: 600, marginBottom: 4 }}>Fluxo de treinos</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#7c3aed" }}>
            1. Bot envia menu com semanas restantes do mês<br />
            2. Paciente digita o número da semana<br />
            3. Bot exibe treinos daquela semana com exercícios
          </Typography>
          <Box style={{ marginTop: 8 }}>
            <Typography style={{ fontSize: "0.8rem", color: "#5b21b6", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
            <Typography style={{ fontSize: "0.8rem", color: "#7c3aed" }}>
              🟣 <strong>concluido</strong> — semana exibida com sucesso<br />
              ⚫ <strong>semTreinos</strong> — sem cronograma cadastrado<br />
              🔴 <strong>erro</strong> — falha na API ou integração inativa
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderScTreinosModal;
